<p>
  <input type="checkbox" id="terms-of-use" [formControl]="fc" />
  <label for="terms-of-use"> I agree with </label>
  <a routerLink="/privacy-policy">Privacy Policy</a>
  <label for="terms-of-use">
    (including Use of Cookies and Other Technologies) and
  </label>
  <a routerLink="/terms-of-use">Terms of Use</a>
  <label for="terms-of-use">.</label>
</p>
